/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    photoFor: 'Photo for',
    emailAddress: 'Email address',
    initials: 'Initials'
};
//# sourceMappingURL=strings.js.map